import React from "react";

function Card({image, title, description}) {
  return (
      <div className="flex w-96 flex-col justify-center bg-white rounded-2xl shadow-xl shadow-gray-400/20 m-1 mb-16">
        <img
          className="aspect-video w-96 rounded-t-2xl object-contain object-center "
          src={image}
        />
        <div className="p-6">
          {/* <small className="text-gray-900 text-xs">{title}</small> */}
          <h1 className="text-2xl font-medium text-gray-700 pb-2">{title}</h1>
          <p className="text text-gray-500 leading-6">{description}</p>
        </div>
      </div>
  );
}

export default Card;
